import { BreadcrumbJsonLd, FAQPageJsonLd, NextSeo } from 'next-seo';
import Head from 'next/head';
import React from 'react';
import { getBreadCrumbsJSONldData } from '../../../datafetchers/CategoryPage';
import { getStructuredData } from '../../StoreCategoryPage/common';

function CategoryL2PageHead(props) {
  const {
    metaTitle,
    metaDescription,
    openGraphData,
    faqsData,
    breadCrumbsData,
    categoryUrl,
    categoryProducts,
    categoryId,
  } = props;
  const itemsListArray = categoryProducts?.slice(0, 6)?.map((data, index) => {
    let itemsData = getStructuredData(data, index, categoryId);
    return JSON.stringify(itemsData);
  });
  return (
    <>
      <NextSeo
        title={metaTitle}
        description={metaDescription}
        openGraph={openGraphData}
        canonical={`https://mylofamily.com${categoryUrl}`}
      />
      {faqsData?.length > 0 && <FAQPageJsonLd mainEntity={faqsData} />}
      {breadCrumbsData?.length > 0 && (
        <BreadcrumbJsonLd
          itemListElements={getBreadCrumbsJSONldData(breadCrumbsData)}
        />
      )}
      <Head>
        {itemsListArray?.length > 0 && (
          <>
            <script
              type="application/ld+json"
              nonce=""
              id="jsonLD"
              dangerouslySetInnerHTML={{
                __html: `{"@context":"http://schema.org","@type":"ItemList","itemListElement":[${itemsListArray}]
                    }`,
              }}
            ></script>
          </>
        )}
        <meta name="google" content="notranslate" />
      </Head>
    </>
  );
}

export default CategoryL2PageHead;
